import React from 'react'
import Modal from "../../../../Components/Modals/modal";
import AddPeople from "../Add-People-Modal/index";
import deleteIcon from "../../../../../images/new-images/delete.svg";
import GoalSettingWorksheetsLogo from "../../../../../images/new-images/goalseetingworksheet.png";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import './Manage-WorkSheet.css'

const ResponsiveManageWorkSheet = (props) => {
    return (
        <div className="resopnsive-manage-worksheet">
            <div className='header'>
                <div style={{ display: "flex" }}>
                    <img className="headerIcon" src={GoalSettingWorksheetsLogo} alt="page icon" />
                    <p className="headerText">Manage Worksheet</p>
                </div>
                <button className="button" onClick={props.handleAddModal}>ADD PEOPLE</button>
            </div>
            <Modal
                assessmentModal={props.AddModal}
                handleModalClose={props.handleModalClose}
                modalHeading="ADD PEOPLE"
            >
                <AddPeople />
            </Modal>
            {props.sharedTo.shared_with_list && props.sharedTo.shared_with_list.map((sharedList, index) => {
                return (
                    <div key={index}>
                        <Row onClick={() => props.toggleCollapse(sharedList.id)}>
                            <p className="head-name">
                                {sharedList.shared_to__short_name}
                            </p>
                            <i
                                className={props.collapseID === sharedList.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                                aria-hidden="true"
                            />
                        </Row>
                        <hr />
                        <Collapse isOpen={props.collapseID === sharedList.id}>
                            <CardBody>
                                <Row>
                                    <Col className="title">Email :</Col>
                                    <Col className="info">
                                        {sharedList.shared_to__email}
                                    </Col>
                                </Row>
                                <Row className='delete'><img className='delete' src={deleteIcon} /></Row>
                            </CardBody>
                        </Collapse>
                    </div>
                );
            })}
        </div>
    );
};

export default ResponsiveManageWorkSheet;




// WEBPACK FOOTER //
// ./src/new/Dashboard/Admin/Manage-WorkSheet/Responsive/Manage-WorkSheet.jsx